import './Footer.css';
import footerImg from '../../assets/images/footer_img.png';

function Footer({ onOpenLegal }) {
  return (
    <footer id="contact" className="footer">
      <div className="footer__main">
        <div className="footer__brand">
          <img src={footerImg} alt="Rocaille" className="footer__logo-img" />
          <div className="footer__social">
            <a href="https://www.instagram.com/rocaille_duesseldorf/" target="_blank" rel="noopener noreferrer" className="footer__social-link">Instagram</a>
            <a href="https://www.facebook.com/Rocaille.Brasserie/?locale=de_DE" target="_blank" rel="noopener noreferrer" className="footer__social-link">Facebook</a>
          </div>
          <div className="footer__contact">
            <a href="tel:+4921197711737" className="footer__contact-link">+49 (0)211 97711737</a>
            <a href="mailto:genuss@rocaille.de" className="footer__contact-link">genuss@rocaille.de</a>
          </div>
        </div>

        <div>
          <span className="footer__col-title">Adresse</span>
          <div className="footer__maps">
            <div className="footer__map-col">
              <a
                href="https://maps.app.goo.gl/bmdrRDsTw4N9rFcj6"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__map-link"
              >
                <iframe
                  className="footer__map-embed"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2491!2d6.7826416!3d51.2461054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b8c99261db6bf5%3A0x1234b07452227769!2sROCAILLE%20-%20Caf%C3%A9%2C%20Patisserie%2C%20Bistrot%20%26%20WineBar%20-%20D%C3%BCsseldorf!5e0!3m2!1sde!2sde!4v1715609420000!5m2!1sde!2sde"
                  title="Rocaille Standort"
                  loading="lazy"
                  allowFullScreen
                />
              </a>
              <address className="footer__address">
                <p>Weissenburgstr. 19, 40476 Düsseldorf</p>
              </address>
            </div>

            <div className="footer__map-col">
              <a
                href="https://maps.google.com/maps?q=Parkhaus+M%C3%BCnster-Center+D%C3%BCsseldorf"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__map-link"
              >
                <iframe
                  className="footer__map-embed"
                  src="https://maps.google.com/maps?q=Parkhaus+M%C3%BCnster-Center+D%C3%BCsseldorf&z=16&output=embed"
                  title="Parkhaus Münster-Center"
                  loading="lazy"
                  allowFullScreen
                />
              </a>
              <address className="footer__address">
                <p>Nächstgelegenes Parkhaus: Münster-Center</p>
              </address>
            </div>
          </div>
        </div>

        <div>
          <span className="footer__col-title">Öffnungszeiten</span>
          <div className="footer__hours">
            <div className="footer__hours-section-label">Restaurant &amp; Bar</div>
            <div className="footer__hours-item">
              <span className="footer__hours-day">Mo – Sa</span>
              <span>11:00 – 23:00</span>
            </div>
            <div className="footer__hours-item">
              <span className="footer__hours-day">So</span>
              <span>geschlossen</span>
            </div>
            <div className="footer__hours-section-label">Küche</div>
            <div className="footer__hours-item">
              <span className="footer__hours-day">Mo – Do</span>
              <span>11:00 – 15:00 &amp; 17:00 – 22:00</span>
            </div>
            <div className="footer__hours-item">
              <span className="footer__hours-day">Fr – Sa</span>
              <span>11:00 – 22:00</span>
            </div>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <p className="footer__copy">
          &copy; {new Date().getFullYear()} Rocaille Düsseldorf. Alle Rechte vorbehalten.
        </p>
        <div className="footer__legal">
          <button className="footer__legal-link" onClick={() => onOpenLegal('impressum')}>Impressum</button>
          <button className="footer__legal-link" onClick={() => onOpenLegal('datenschutz')}>Datenschutz</button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
